/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_Group_AriaInputs */



/**
* | output |
* | --- |
* | "Select group to manage" |
*
* @param {Team_Manager_Select_Group_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_group_aria = /** @type {((inputs?: Team_Manager_Select_Group_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_Group_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner le groupe à gérer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe zur Verwaltung auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il gruppo da gestire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группу для управления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el grupo a administrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要管理的组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("管理するグループを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रबंधित करने के लिए समूह का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o grupo a ser gerenciado")
	return /** @type {LocalizedString} */ ("Select group to manage")
});